import React from 'react';
import { observer } from 'mobx-react';
import { TeamMemberStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class TeamMemberCreate extends React.Component {

  onCreate = name => {
    TeamMemberStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Name for new team member'
        onCreate={this.onCreate}
      />
    );
  }
}

export default TeamMemberCreate;